import * as tslib_1 from "tslib";
import { ItemContainer } from './item_container';
var Form = /** @class */ (function (_super) {
    tslib_1.__extends(Form, _super);
    function Form(param) {
        return _super.call(this, param) || this;
    }
    Form.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "Form" });
    };
    Form.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Form;
}(ItemContainer));
export { Form };
//# sourceMappingURL=form.js.map